import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { useCreateMigrationMutation } from '../../redux/services/migrationsApi';

const MigrationScreen = props => {
  const [migrate] = useCreateMigrationMutation();
  return (
    <Stack direction='row'>
      <Button
        color='error'
        variant='contained'
        onClick={migrate}
      >
        Run Migration
      </Button>
    </Stack>
  );
};

export default MigrationScreen;